import { useState } from 'react';
import { toast } from 'material-react-toastify';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { BasketItem } from '../../interfaces/Basket/BasketItem';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';
import { deleteBasketItem } from '../../api/Basket';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import { Waiting } from '../../components/Waiting/Waiting';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<BasketItem>[] = [
  {
    id: 'product-name',
    name: 'Ürün Adı',
    accessor: (row) => <TextColumn value={row.productName} />,
  },
  {
    id: 'option-name',
    name: 'Varyant',
    accessor: (row) => <TextColumn value={row.optionName ?? ''} />,
  },
  {
    id: 'quantity',
    name: 'Sepetteki Adet',
    accessor: (row) => <TextColumn value={row.quantity.toString()} />,
  },
  {
    id: 'stock',
    name: 'Stok',
    accessor: (row) => <TextColumn value={row.stock.toString()} />,
  },
];

type BasketItemsTableProps = {
  basketItems: BasketItem[];
  onDelete: () => void;
};

export const BasketItemsTable = (props: BasketItemsTableProps) => {
  const [loading, setLoading] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<BasketItem | undefined>(
    undefined,
  );

  const deleteColumn: TableColumn<BasketItem> = {
    id: 'delete',
    name: 'İşlem',
    align: 'center',
    accessor: (row) => (
      <ButtonColumn
        label='Sepetten Çıkar'
        onClick={() => setItemToDelete(row)}
      />
    ),
  };

  const handleClickRow = (row: BasketItem) => {
    const url = `/products/catalog/${row.productID}`;
    window.open(url, '_blank');
  };

  const handleDelete = () => {
    if (!itemToDelete) {
      return;
    }

    setLoading(true);
    deleteBasketItem(itemToDelete.id)
      .then(() => {
        toast.success('Ürün başarıyla sepetten çıkarıldı');
        setItemToDelete(undefined);
        props.onDelete();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <ConfirmDialog
        content='Gerçekten seçili ürünü kullanıcının sepetinden çıkarmak istiyor musunuz'
        open={!!itemToDelete}
        onClose={() => setItemToDelete(undefined)}
        onConfirm={handleDelete}
        color='error'
      />
      <Waiting open={loading} />

      <DataTable
        columns={[...columns, deleteColumn]}
        totalCount={props.basketItems.length}
        rows={props.basketItems}
        hidePagination
        onClick={handleClickRow}
      />
    </>
  );
};
